import { useMutation, useQueryClient } from '@tanstack/react-query';

// models
import { FormulaAddLabelModel } from '../../models/formula.model';

// services
import API from '../../services/api';

// constants
import formulaKeys from './_queryKeys';

export default function useFormulaLabelsAddMutation() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (updates: FormulaAddLabelModel) =>
            API.addFormulaLabels(updates),

        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: formulaKeys.all });
            queryClient.invalidateQueries({
                queryKey: ['personalization-map'],
            });
        },
    });
}
